import { configureStore } from '@reduxjs/toolkit';
import rootReducer from './rootReducer';
import reduxLogger from 'redux-logger';


export default configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(reduxLogger)
})